var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "flex justify-between items-stretch shadow-border-b mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 shadow-border-r p-6 mdmax:shadow-border-b mdmax:w-full mdmax:flex-auto"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info Partner")]), _c('div', {
    staticClass: "mb-6 max-w-sm"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "ID",
      "disabled": true
    },
    model: {
      value: _vm.id,
      callback: function ($$v) {
        _vm.id = $$v;
      },
      expression: "id"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Nama",
      "placeholder": "Nama partner"
    },
    model: {
      value: _vm.payloads.name,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "name", $$v);
      },
      expression: "payloads.name"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "No. Handphone",
      "placeholder": "No Handphone"
    },
    model: {
      value: _vm.payloads.phone_number,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "phone_number", $$v);
      },
      expression: "payloads.phone_number"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "Alamat Email",
      "placeholder": "Alamat Email"
    },
    model: {
      value: _vm.payloads.email,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "email", $$v);
      },
      expression: "payloads.email"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('Textarea', {
    attrs: {
      "label": "Alamat",
      "placeholder": "Alamat"
    },
    model: {
      value: _vm.payloads.address,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "address", $$v);
      },
      expression: "payloads.address"
    }
  })], 1), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Kota / Wilayah")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.cities,
      "default": _vm.selectedCity,
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedCity,
      callback: function ($$v) {
        _vm.selectedCity = $$v;
      },
      expression: "selectedCity"
    }
  })], 1)]), _c('div', {
    staticClass: "flex-1 mdmax:w-full mdmax:flex-auto"
  }, [_c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("No. Rekening")]), _c('div', {
    staticClass: "mb-6"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama Bank")]), _c('CustomSelect', {
    attrs: {
      "options": _vm.bankCodes,
      "default": _vm.selectedBank,
      "placeholder": "Pilih nama bank",
      "optionLabel": "name"
    },
    model: {
      value: _vm.selectedBank,
      callback: function ($$v) {
        _vm.selectedBank = $$v;
      },
      expression: "selectedBank"
    }
  })], 1), _c('div', {
    staticClass: "mb-12"
  }, [_c('TextField', {
    attrs: {
      "type": "text",
      "label": "No. Rekening",
      "placeholder": "Masukan nomor rekening"
    },
    model: {
      value: _vm.payloads.bank_account,
      callback: function ($$v) {
        _vm.$set(_vm.payloads, "bank_account", $$v);
      },
      expression: "payloads.bank_account"
    }
  })], 1), _c('div', {}, [_c('FileBrowser', {
    attrs: {
      "id": "stnk",
      "accept": ".jpg, .png, .jpeg",
      "label": "Upload Dokumen",
      "button": "Browse",
      "placeholder": "Pilih file yang akan di upload"
    },
    on: {
      "change": function ($event) {
        return _vm.handleFileSelect($event, 'stnk', 'idcard_file_url');
      }
    }
  }), _vm.payloads.idcard_file_url ? _c('div', {
    staticClass: "w-40 mt-4"
  }, [_c('img', {
    attrs: {
      "src": _vm.payloads.idcard_file_url
    }
  })]) : _vm._e()], 1)])])]), _c('div', {
    staticClass: "flex gap-6 p-6 justify-end"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Simpan",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.submit();
      }
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }